import { useConfig } from "config";

import { useFeatureFlag } from "features/feature-flags";

export default function useIsPlurallApp() {
  const { config } = useConfig();
  const isPlurallApp = (config && config.isPlurallApp) as boolean;

  return !!useFeatureFlag("isPlurallApp") || isPlurallApp;
}
